import { Component, Input } from '@angular/core';
import { EonUiComponentsAngularModule } from '@eon-ui/eon-ui-components-angular';
import { TranslateModule } from '@ngx-translate/core';
import { AutowireI18n } from '@eon-is/ts-utils';
import enLocal from './i18n/en.json';
import deLocal from './i18n/de.json';
import huLocal from './i18n/hu.json';

@Component({
    selector: 'app-legal-links',
    standalone: true,
    imports: [
        EonUiComponentsAngularModule,
        TranslateModule,
    ],
    templateUrl: './legal-links.component.html',
    styleUrl: './legal-links.component.scss',
})
@AutowireI18n({ en: enLocal, de: deLocal, hu: huLocal })
export class LegalLinksComponent {

    @Input() public iconPosition!: string;

}
